import { Stack, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export function MprPanelHeading({ title, hint }: { title: string; hint: string }) {
  return (
    <Stack direction='row' alignItems='baseline' gap='0.5rem' flexWrap='wrap'>
      <Typography variant='subtitle2'>{title}</Typography>
      <Typography variant='caption' color='text.secondary'>
        {hint}
      </Typography>
    </Stack>
  );
}

export function MprEmptyListText({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <Typography
      variant='body2'
      color='text.secondary'
      textAlign='center'
      py='3rem'
      className={className}
      // the css prop lands here as a class, so the empty state keeps the list's height
    >
      {children}
    </Typography>
  );
}
